import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "booking-type-selector" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["name", "value", "onChange", "onBlur"]
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_6 = { class: "student-booking-type-info" }
const _hoisted_7 = { class: "form-control-plaintext" }

import { computed, watch, onMounted } from "vue";
import { useMasterDataHelpers } from "../composables/useMasterDataHelpers";


export default {
  __name: 'BookingTypeSelector',
  props: {
	form: {
		type: Object,
		required: true,
	},
	mode: {
		type: String,
		default: "create",
	},
},
  setup(__props) {

const props = __props;

const masterData = useMasterDataHelpers();

// Check if current user is a student
const isStudentUser = computed(() => {
	return masterData.userRole.value === "student";
});

// Get available booking types sorted alphabetically
const availableBookingTypes = computed(() => {
	const bookingTypes = masterData.bookingTypesList.value || [];
	return bookingTypes.slice().sort((a, b) => a.title.localeCompare(b.title));
});

// Get the default booking type for students
const defaultBookingType = computed(() => {
	return masterData.defaultBookingType.value;
});

// Auto-select student default booking type when user is a student
watch(
	() => isStudentUser.value,
	(isStudent) => {
		if (isStudent && defaultBookingType.value) {
			try {
				// Only set if there's no existing value to avoid overriding pre-filled data
				const currentValue = props.form.getFieldValue?.("bookingTypeId");
				if (!currentValue && props.form?.setFieldValue) {
					props.form.setFieldValue(
						"bookingTypeId",
						defaultBookingType.value.id
					);
				}
			} catch (error) {
				console.warn("Failed to set bookingTypeId:", error);
			}
		}
	},
	{ immediate: true }
);

// Auto-set default booking type on mount for students
onMounted(() => {
	if (
		isStudentUser.value &&
		defaultBookingType.value &&
		!props.form.state?.values?.bookingTypeId
	) {
		try {
			if (props.form?.setFieldValue) {
				props.form.setFieldValue("bookingTypeId", defaultBookingType.value.id);
			}
		} catch (error) {
			console.warn("Failed to set bookingTypeId:", error);
		}
	}
});

// Extract form for template
const { form } = props;

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Show dropdown only if user is NOT a student "),
    _createVNode(_unref(form).Field, {
      name: "bookingTypeId",
      validators: {
        onChange: ({ value }) =>
          !value ? 'Nutzungsart ist erforderlich' : undefined,
      }
    }, {
      default: _withCtx(({ field }) => [
        (!isStudentUser.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[1] || (_cache[1] = _createElementVNode("label", {
                for: "bookingTypeSelect",
                class: "form-label"
              }, [
                _createTextVNode(" Nutzungsart "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1 /* CACHED */)),
              _createElementVNode("select", {
                id: "bookingTypeSelect",
                name: field.name,
                value: field.state.value,
                class: _normalizeClass(["form-select", { 'is-invalid': field.state.meta.errors.length > 0 }]),
                onChange: (e) => field.handleChange(e.target.value),
                onBlur: field.handleBlur
              }, [
                _cache[0] || (_cache[0] = _createElementVNode("option", {
                  value: "",
                  disabled: ""
                }, " Nutzungsart auswählen ", -1 /* CACHED */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableBookingTypes.value, (bookingType) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: bookingType.id,
                    value: bookingType.id
                  }, _toDisplayString(bookingType.title), 9 /* TEXT, PROPS */, _hoisted_4))
                }), 128 /* KEYED_FRAGMENT */))
              ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_3),
              (field.state.meta.errors.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(field.state.meta.errors[0]), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]))
          : (defaultBookingType.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createCommentVNode(" For students, show the default booking type as read-only "),
                _createElementVNode("div", _hoisted_6, [
                  _cache[2] || (_cache[2] = _createElementVNode("label", { class: "form-label" }, "Nutzungsart", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(defaultBookingType.value.title), 1 /* TEXT */),
                  _cache[3] || (_cache[3] = _createElementVNode("small", { class: "text-muted" }, " Als Student wird automatisch diese Nutzungsart verwendet. ", -1 /* CACHED */))
                ])
              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
            : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["validators"])
  ]))
}
}

}